<template>
  <div class="custom-orders fullscreen-content">
    <banner :banner="page.data.page.main_banner"></banner>
    <div class="container is-md section">
      <div class="row content">
        <div class="col-6 col-sm-12">
          <h2>{{page.data.page.left_text}}</h2>
        </div>
        <div class="col-6 col-sm-12" v-html="page.data.page.right_text"></div>
      </div>
    </div>

    <slider :component="'job'" :items="page.data.jobs" :title="$t('our_works')" :slide_count="3"></slider>

    <div class="container section" ref="request">
      <div class="row request-custom-order">
        <div class="col-6 col-md-12">
          <h2>{{$t('request_form_title')}}</h2>
          <p v-html="$t('request_form_content')"></p>
        </div>
        <div class="col-6 col-md-12">
          <div class="request-form">
            <div class="form-field">
              <input type="text" placeholder="Անուն" />
            </div>
            <div class="form-field">
              <input type="text" placeholder="Հեռախոս" />
            </div>
            <div class="form-field">
              <input type="text" placeholder="Էլ․ փոստ" />
            </div>
            <div class="form-field">
              <input type="text" placeholder="Կազմակերպություն" />
            </div>
            <div class="form-field">
              <textarea name id cols="30" rows="10" placeholder="Նամակ"></textarea>
            </div>
            <div class="form-field">
              <button class="button">{{$t('request_form_submit')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/home/Banner.vue';
import Job from '@/components/items/Job.vue';
import Slider from '@/components/home/Slider.vue';
import { mapState } from 'vuex';
export default {
  components: {
    Banner,
    Job,
    Slider
  },
  name: 'custom-order',
  i18n: {
    messages: {
      en: {
        our_works: 'OUR WORKS',
        request_form_title: '',
        request_form_content: '',
        request_form_submit: 'SEND NOW'
      },
      hy: {
        our_works: 'Մեր բոլոր աշխատանքները',
        request_form_title: "Գրե՛ք մեզ և մեր մասնագետները Ձեզ կօգնեն իրականացնել կորպորատիվ նվերներ պատրաստելու Ձեր գաղափարը",
        request_form_content: "Եթե ցանկանում եք պատվիրել կորպորատիվ յուրօրինակ նվերներ զանգահարեք մեզ <a href='tel:+374 98 228 228'>+374 98 228 228</a> հեռախոսահամարով կամ գրե՛ք մեզ և մեր մասնագետները սիրով կօգնենք Ձեզ կողմնորոշվել նվերի հարցում՝ առաջարկելով լավագույն լուծումը Ձեզ համար։",
        request_form_submit: 'ՈՒՂԱՐԿԵԼ'
      }
    }
  },
  data () {
    return {
      banner: {
        image: '/img/custom-order/banner.jpg',
        title: 'Յուրահատուկ<br>կորպորատիվ նվերներ',
        description:
          'Եթե փնտրում եք նվերներ Ձեր ընկերության աշխատակիցների և գործընկերի համար, ցանկանում եք տոնական անակնկալներ մատուցել, մենք ունենք փորձառություն յուրահատուկ նվերներ պատրաստելու գործում:',
        cta_text: 'Ուղարկել հայտ',
        cta_action: '/hy/custom-orders/job#request'
      }
    }
  },
  computed: mapState(['page'])
}
</script>

<style lang="scss">
.custom-orders {
  padding-top: 95px;

  .banner {
    .banner-caption {
      max-width: 500px;
    }
  }

  @include mq($lg) {
    padding-top: 65px;
  }

  .content {
    h2 {
      font-family: $font-bold;
    }
    h2,
    p {
      margin: 0;
    }
  }

  .request-custom-order {
    background: #eff0f0;
    padding: 70px 100px;

    @include mq($lg) {
      padding: 50px 30px;
    }

    h2 {
      margin-top: 0;
      font-family: $font-bold;
      font-size: 24px;
    }
    p {
      margin: 0;
      a {
        font-family: $font-bold;
      }
    }
    input,
    textarea {
      background: none;
    }
    textarea {
      height: 100px;
      resize: none;
      border: 1px solid #0b0b0b;
      padding-top: 15px;
    }
    .button {
      max-width: 60%;
    }
  }
}
</style>
